export default "__VITE_ASSET__BNkORPid__";